import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TypeAnimation } from 'react-type-animation';
import './HeroSection.css';
import {FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

const HeroSection = () => {
  const navigate = useNavigate();

  const handleJoinUsClick = () => {
    navigate('/contact');
  };

  const handleLearnMoreClick = () => {
    navigate('/about');
  };

  return (
    <div className="hero-container">
      <div className="hero-content">
        <h1 className="hero-title">Welcome to PCE ACM</h1>

        <TypeAnimation
          sequence={[
            'We Innovate with Technology.',
            1000,
            'We Create Future Leaders.',
            1000,
            'We Transform Ideas into Reality.',
            1000,
          ]}
          wrapper="span"
          speed={50}
          className="hero-subtitle-animated"
          repeat={Infinity}
        />

        <div className="hero-buttons">
          <button className="hero-btn join-us" onClick={handleJoinUsClick}>
            Join Us
          </button>
          <button className="hero-btn learn-more" onClick={handleLearnMoreClick}>
            Learn More
          </button>
        </div>

        <div className="hero-socials">
          <a href="https://www.facebook.com/profile.php?id=100063974004280" className="social-icon" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
          <a href="https://x.com/Pceacmchapter" className="social-icon" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
          <a href="https://www.instagram.com/pceacmchapter/" className="social-icon" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://www.linkedin.com/company/acm-student-chapter-pce/posts/?feedView=all" className="social-icon" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
